angular.module('leanlaw').factory('singleRequest', ['$q', '$rootScope', 'leanLawApi', 'apiCache', function ($q, $rootScope, leanLawApi, apiCache) {
  const requests = {};
  const apiRequests = {};
  return {
    cancel(name) {
      if (requests[name]) {
        requests[name].resolve();
      }
      if (apiRequests[name]) {
        apiRequests[name].resolve();
      }
    },
    // singleRequest.serviceCall(name, reportsService.getClientReport)(query)
    serviceCall(requestName, requestFn) {
      if (typeof requestName == "function") throw "requestName may not be a function; check your argument parameters";

      // Return a function that includes request cancel promise already populated
      return function requestHandler(...args) {
        if (requests.hasOwnProperty(requestName)) {
          // Request in progress, cancel old one
          requests[requestName].resolve();
        }
        requests[requestName] = $q.defer();

        // Handle request success
        return requestFn(...args, requests[requestName].promise).then(results => {
          if (!results) return;
          return results;
        });
      };
    },
    // singleRequest.apiCall(name).<any leanLawApi method name>(params).then() ...
    apiCall(requestName, cached) {
      // Determine which functions are available in llApi
      const functionNames = Object.getOwnPropertyNames(leanLawApi.__proto__);

      // Setup
      return functionNames.reduce((accum, fn) => {
        // Immediately-executing function that returns a function
        // handler for each leanLawApi method, stores it in an object
        // to be called later (so that fn can be chained)
        accum[fn] = function (requestName) {
          return function (parameters = {}) {
            if (!leanLawApi.__proto__.hasOwnProperty(fn)) throw `leanLawApi doesn't have method ${fn}`;

            // Cancel old requests
            if (apiRequests.hasOwnProperty(requestName)) {
              apiRequests[requestName].resolve();
            }
            apiRequests[requestName] = $q.defer();

            // Inject timeout promise
            parameters = Object.assign(parameters, {
              $timeout: apiRequests[requestName].promise
            });
            return apiCache.call(fn, parameters, cached && requestName);
          };
        }(requestName);
        return accum;
      }, {});
    }
  };
}]);